<template>
    <div class="relative flex justify-end w-full">
        <Link :href="link" class="w-full my-2">
        <div data-testid="fruit-list-card" class="flex w-full min-w-0 px-3 transition-all shadow-md sm:px-5 md:px-1 md:h-20 rounded-3xl bg-light_yellow hover:shadow-lg hover:bg-yellow">
            <button @click="addToFavorites()" v-if="$page.props.user != null && !isInFavorites"><img class="w-4 mx-2" src="/images/favorite-enriqueto.png" alt=""></button>
            <button @click="removeToFavorites()" v-if="$page.props.user != null && isInFavorites"><img class="w-4 mx-2" src="/images/favorite-fill-enriqueto.png" alt=""></button>
            <img
                class="hidden object-cover w-12 h-12 m-5 bg-white border-2 rounded-full border-enriqueto_green md:block"
                :src="fruit.image"
                :alt="fruit.name"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
            />
            <div class="grid w-full min-w-0 grid-cols-4 gap-3 pb-3 align-middle transition-all md:pb-0 md:gap-4 md:grid-cols-7 xl:gap-8 rounded-3xl">
                <div class="flex items-center min-w-0 col-span-3 pt-3 md:pt-0 md:col-span-1">
                    <img
                        class="block object-cover flex-shrink-0 w-16 h-16 m-1 bg-white border-2 rounded-full border-enriqueto_green md:hidden"
                        :src="fruit.image"
                        :alt="fruit.name"
                        width="64"
                        height="64"
                        loading="lazy"
                        decoding="async"
                    />
                    <div class="min-w-0">
                        <div class="m-3 text-enriqueto_green md:m-0">
                            <p class="font-bold leading-tight break-words"><strong>{{fruit.name}}</strong></p>
                            <p class="mt-1 font-normal leading-snug break-words md:hidden">{{usePriceFormat(fruit.price)}} / {{fruit.unit}}</p>
                        </div>
                    </div>
                </div>
                <div class="h-16 col-span-1 mt-2 md:col-span-1 md:hidden">
                    <vue3-chart-js
                        :id="lineGraphChart.id + '-mobile'"
                        :type="lineGraphChart.type"
                        :data="lineGraphChart.data"
                        :options="lineGraphChart.options"
                        @before-render="beforeRenderLogic"
                    ></vue3-chart-js>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold text-enriqueto_green md:hidden">Precio</p>
                    <p class="text-enriqueto_green">{{usePriceFormat(fruit.price)}} / {{fruit.unit}}</p>
                </div>
                <div class="col-span-4 pb-3 fruit-mobile-stats md:hidden">
                    <div class="bg-white bg-opacity-40 rounded-xl fruit-mobile-market">
                        <p class="flex-shrink-0 text-sm font-bold text-enriqueto_green">Mercado</p>
                        <p data-testid="mobile-market-value" class="font-semibold text-enriqueto_green fruit-mobile-market-value">{{useMarketValueFormat(fruit.marketcap)}}</p>
                    </div>
                    <div class="fruit-mobile-changes">
                        <div class="fruit-mobile-change">
                            <p class="text-sm font-bold text-enriqueto_green">1H</p>
                            <p class="text-sm font-bold whitespace-nowrap" :class="movementClass(fruit.hour_increase)">{{formatMovement(fruit.hour_increase)}}</p>
                        </div>
                        <div class="fruit-mobile-change">
                            <p class="text-sm font-bold text-enriqueto_green">24H</p>
                            <p class="text-sm font-bold whitespace-nowrap" :class="movementClass(fruit.increase)">{{formatMovement(fruit.increase)}}</p>
                        </div>
                        <div class="fruit-mobile-change">
                            <p class="text-sm font-bold text-enriqueto_green">7D</p>
                            <p class="text-sm font-bold whitespace-nowrap" :class="movementClass(fruit.week_increase)">{{formatMovement(fruit.week_increase)}}</p>
                        </div>
                    </div>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold" :class="movementClass(fruit.hour_increase)">{{formatMovement(fruit.hour_increase)}}</p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold" :class="movementClass(fruit.increase)">{{formatMovement(fruit.increase)}}</p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold" :class="movementClass(fruit.week_increase)">{{formatMovement(fruit.week_increase)}}</p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold text-enriqueto_green md:hidden">Mercado</p>
                    <p class="text-enriqueto_green">{{useMarketValueFormat(fruit.marketcap)}}</p>
                </div>
                <div class="hidden col-span-3 my-3 md:h-12 md:col-span-1 md:block">
                    <vue3-chart-js
                        :id="lineGraphChart.id + '-desktop'"
                        :type="lineGraphChart.type"
                        :data="lineGraphChart.data"
                        :options="lineGraphChart.options"
                        @before-render="beforeRenderLogic"
                    ></vue3-chart-js>
                </div>
            </div>

        </div>
        </Link>
    </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { Link } from '@inertiajs/inertia-vue3'
import usePriceFormat from '../../Services/usePriceFormat'
import {useMarketValueFormat, usePriceFormatShort} from '../../Services/usePriceFormat'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    components: {
        Vue3ChartJs,
        Link
    },
    props: ['fruit','link'],
    setup (props) {
    const formatMovement = value => value === null || value === undefined ? '—' : `${value}%`
    const movementClass = value => value === null || value === undefined
        ? 'text-gray'
        : (value >= 0 ? 'text-enriqueto_green' : 'text-red')
    const store = useStore()
    const api = useApi()
    const notificate = useNotification()
    const currentPrice = Number(props.fruit.price)
    const reports = (props.fruit.last_reports || [])
        .map(report => ({
            value: Number(report.value),
            created_at: report.created_at
        }))
        .filter(report => Number.isFinite(report.value))
        .slice(-7)
    let value_report = reports.map(({ value }) => value)
    let date_report = reports.map(({ created_at }) => created_at)
    const isInFavorites = computed(() => store.state.favorites.includes(props.fruit.id));
    if (Number.isFinite(currentPrice) && (value_report.length === 0 || value_report[value_report.length - 1] !== currentPrice)) {
        value_report.push(currentPrice)
        date_report.push('Actual')
    }
    if(value_report.length<2){
        const fallbackPrice = Number.isFinite(currentPrice) ? currentPrice : 0
        value_report = [
            fallbackPrice,
            fallbackPrice
        ]
        date_report = [
            'Inicio',
            'Actual'
        ]
    }
    const firstValue = Number(value_report[0])
    const lastValue = Number(value_report[value_report.length - 1])
    const trend = Number.isFinite(firstValue) && Number.isFinite(lastValue)
        ? Math.sign(lastValue - firstValue)
        : 0
    const borderColor = trend > 0 ? '#08783e' : (trend < 0 ? '#c83e4d' : '#718078')
    const lineGraphChart = {
        id: 'lineGraph'+props.fruit.id,
        type: 'line',
        data: {
            labels: date_report,
            datasets: [{ 
                data: value_report,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
                fill: false,
                backgroundColor: 'transparent',
                borderWidth: 1.75,
                borderCapStyle: 'round',
                borderJoinStyle: 'round',
                spanGaps: true
            }
            ]
        },
        options: {
            elements: {
                line: {
                    tension: 0.28
                }
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                }
            },
            layout: {
                padding: { top: 5, right: 1, bottom: 5, left: 1 }
            },
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 250,
            },
            interaction: {
                mode: 'index',
                intersect: false
            },
            scales: {
                x: {
                    display: false,
                },
                y: {
                    display: false,
                    grace: '12%',
                }
            }
        },
    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    const addToFavorites = () => {
        let values = {fruit_id:props.fruit.id}
        api.addFruitToFavorites(values).then((res)=>{
            let favorites = res.data.favorites.map(item=>item.id)
            store.commit('setFavorites',favorites)
            Inertia.reload()
        })
    }
    const removeToFavorites = () => {
        let values = {fruit_id:props.fruit.id}
        api.removeFruitToFavorites(values).then((res)=>{
            let favorites = res.data.favorites.map(item=>item.id)
            store.commit('setFavorites',favorites)
            Inertia.reload()
        })
    }

        return {
        lineGraphChart,
        beforeRenderLogic,
        usePriceFormat,
        useMarketValueFormat,
        usePriceFormatShort,
        addToFavorites,
        removeToFavorites,
        isInFavorites,
        formatMovement,
        movementClass
        }
    },
}
</script>

<style>

</style>
